export const AccountType = [
  'select-individual',
  'select-joint',
  'select-rothira',
  'select-traditionalira',
  'select-rolloverira',
  'select-custodial',
  'select-roth',
  'select-traditional',
  'select-rollover',
  'select-beneficiaryroth',
  'select-beneficiary',
  'select-coverdell',
  'select-trust'
];
